export default {
  label: {
    message: 'Export as {type}',
  },
};
